// @givmo/board — Self-assessment (CBG-YR4-ASSESS-WEB; shown as "Self-assessment" since CBG-UX8-MENU):
// the board's self-assessment, frames s1–s3, a page of its own after Conflicts of interest in Board's
// flat menu.
//
// It held two parts until D-CBG-35 (1) (Jonathan, 2026-10-22 23:09 PDT): "Evaluations" shows as
// "Self-assessment", and its Compensation decisions moved to the Form 990 page as that page's second
// part (`form990-page.tsx`). The part's old address, this page's `?tab=compensation`, is replaced by
// the host with the Form 990 page's part (`RETIRED_COMPENSATION_TAB`), so a link someone kept still
// opens the decisions. Any other address here opens the self-assessment, as it always did.
//
// DARK UNTIL A CUSTOMER ASKS (CBG-YR4-ASSESS-DARK, Jonathan 2026-10-24: "hide the Self Evaluation"):
// while the backend serves no self-assessment, its list read is the route miss and the menu draws no
// row for it (`useSelfAssessmentServed`, Org Machinery OM-99). An address someone kept lands here, in
// Board's frame, on the part's own line that the self-assessment isn't available (D-CBG-41), never
// on a not-found that says the page moved. Nothing is deleted: a results record already in the minute
// book stays there.

import { PageShell } from '../../components/page-shell';
import { SelfAssessmentPart } from './assessment-part';
import { assessmentWords as w } from './assessment-words';

export function EvaluationsPage() {
  return (
    <PageShell title={w.pageTitle} testId="page-evaluations">
      <SelfAssessmentPart />
    </PageShell>
  );
}
